import { render } from "./KetersediaanKelasPage.vue?vue&type=template&id=61e87625&scoped=true"
import script from "./KetersediaanKelasPage.vue?vue&type=script&lang=js"
export * from "./KetersediaanKelasPage.vue?vue&type=script&lang=js"

import "./KetersediaanKelasPage.vue?vue&type=style&index=0&id=61e87625&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61e87625"]])

export default __exports__